export default "__VITE_ASSET__B0eZGJ_l__"